module.exports = "/images/contact-bg.jpg?91a3d270065f14a570905bb535250aba";